import RegulamentoPage from './regulamento.page'

export default RegulamentoPage
